import type { KieModelConfig } from '../types';

export const recraftConfigs: Record<string, KieModelConfig> = {
    'recraft-remove-background': {
        // https://docs.kie.ai/market/recraft/remove-background
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls } = params;
            return {
                model: 'recraft/remove-background',
                input: {
                    image: image_urls![0],
                },
            };
        },
    },
};